import React, { lazy, Suspense } from "react";
import { useParams } from "react-router-dom";

import { RemoteLogErrorBoundary } from "~/components/common/remote-log-error-boundary";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";
import { useScrollToTop } from "~/hooks/use-scroll-to-top";
import type { NumericString } from "~/types/common";

const LazyAgreementForm = lazy(() => import("./agreement-form"));

export function AgreementPage() {
  const { doctor_agreement_id } = useParams<{ doctor_agreement_id: NumericString }>();

  useIntlDocumentTitle("agreement.title", doctor_agreement_id);
  useScrollToTop();

  return (
    <RemoteLogErrorBoundary component="agreement_page">
      <Suspense fallback={null}>
        <LazyAgreementForm doctorAgreementId={Number(doctor_agreement_id)} />
      </Suspense>
    </RemoteLogErrorBoundary>
  );
}
